/** The "iz" mark from the favicon, as an SVG that follows the current text colour. */
export default function Mark({ className = '', title }) {
  return (
    <svg
      className={className}
      viewBox="140 54 632 811"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <circle cx="456" cy="189" r="135" fill="currentColor" />
      <path fill="currentColor" d="M142 384H768L497.5 736V748H770.5V863H142L416 515V504.5H142Z" />
    </svg>
  );
}
